module.exports = __webpack_public_path__ + "static/media/white_logo.f61996f7.webp";